import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import {
  IAccountPartCategoriesResponse,
  IUpdateAccountPartCategoriesRequest,
} from "../models/account/IAccountPartCategory";
import apiConfig from "../utils/apiConfig";

export default function useAccountPartCategories(
  accountId?: string,
  componentName = "useAccountPartCategories"
) {
  const { get, put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const queryKey = ["accounts", accountId, "part-categories"];

  const accountPartCategories = useQuery({
    queryKey,
    queryFn: () =>
      get<IAccountPartCategoriesResponse>(`/account/${accountId}/part-categories`),
    enabled: !!accountId,
  });

  const update = useMutation({
    mutationFn: (req: IUpdateAccountPartCategoriesRequest) =>
      put(`/account/${accountId}/part-categories`, req),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
      queryClient.invalidateQueries(["accounts", accountId]);
      queryClient.invalidateQueries(["accounts"]);
    },
  });

  return {
    accountPartCategories,
    update,
  };
}
